import Vue from 'vue';
import  filters from "../components/filters.vue";
import  cards  from "../components/cards.vue";


document.addEventListener("DOMContentLoaded", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:insert", function() {
    initFabricSelection();
});
window.addEventListener("Pageeditor:change", function() {
    initFabricSelection();
});

function initFabricSelection() {

    if(document.getElementById('productselection')) {
        new Vue({
            name: 'ProductSelection',
            el: '#productselection',
            components: {
                filters,
                cards
            },
            methods: {

            }
        });
    }
}